export const REMOVE_COOKIE = "REMOVE_COOKIE";